<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Edit Day Schedule</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="day_schedule.name">
          </div>
          <div class="form-group">
            <label for="ddlColor">Color</label>
            <select id="ddlColor" class="form-control" v-model="day_schedule.color">
              <option value="default">Default</option>
              <option value="exception">Exception</option>
              <option value="red">Red</option>
              <option value="black">Black</option>
              <option value="blue">Blue</option>
              <option value="green">Green</option>
              <option value="gray">Gray</option>
              <option value="salmon">Salmon</option>
              <option value="purple">Purple</option>
              <option value="yellow">Yellow</option>
              <option value="pink">Pink</option>
              <option value="olive">Olive</option>
            </select>
          </div>
          <div class="form-group">
            <p :class="'phx-cal-event-' + day_schedule.color" style="height: 30px; width: 30px;"></p>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'DayScheduler' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'day_schedule_id'
  ],
  computed: {
    ...mapGetters({
      day_schedule: 'singleDaySchedule'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDaySchedule', this.day_schedule_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditDaySchedule', this.day_schedule)
    }
  }
}
</script>

<style scoped>

</style>
